var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',_vm._b({class:{
    'border-radius': !_vm.customStyles,
  },attrs:{"dense":"","outlined":"","error-messages":_vm.errorMessage,"label":_vm.label,"value":_vm.value,"rules":_vm.enableRules,"hide-details":_vm.hideDetails,"height":_vm.height,"disabled":_vm.disabled,"auto-grow":_vm.autoGrow,"background-color":_vm.bgColor},on:{"input":function($event){return _vm.updateValue($event)}}},'v-textarea',_vm.settings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }